import React, {useEffect, useState} from "react";

const Timer = ({time, active, reverse, className, onCompleted}) => {
    const [seconds, setSeconds] = useState(time)
    const [isActive, setIsActive] = useState(active)

    useEffect(() => {
        let interval = null;
        if(isActive && seconds > 0){
            interval = setInterval(() => {
               if(reverse){
                   setSeconds(seconds - 1)
               } else {
                   setSeconds(seconds + 1)
               }
            }, 1000)
        } else {
            onCompleted()
        }
        return () => clearInterval(interval)
    }, [isActive, seconds])


    return(
        <span className={`countDown ${className}`}>{seconds}</span>
    )
}

export default Timer